/* ============================================================================
   MoveOn™ Listicle landing page — interactions (SINGAPORE fork)
   ----------------------------------------------------------------------------
   Fork of listicle-au.js for moveon-listicle-singapore.html. Same behavior,
   but the offer is the SG model: four one-time box bundles (1/2/3/6 boxes,
   S$115/205/259/499), no subscription, S$ money.
   Drives:
     • hero carousel   (6 slides, auto-advance, dot controls, reset-on-pick)
     • offer gallery   (cross-fade + thumbnails)
     • bundle + plan   (live pricing across CTA, cart drawer and sticky bar)
     • cart drawer     (slide-in summary, Esc / scrim to close)
     • FAQ + ingredient accordions (single-open)
     • review wall     (3 columns auto-scrolling at different speeds)
     • generations chart (bars grow when the block scrolls in)
     • sticky add-to-cart bar (reveals past 620px)
     • all [data-pro] videos (force muted + looping, never unmutable)
   ============================================================================ */
(function () {
  'use strict';

  var AUTOPLAY_MS = 4000;      // comp prop: autoplaySeconds = 4
  var SHOW_STICKY = true;      // comp prop: showStickyBar = true
  var DEFAULT_PLAN = 'once';   // SG: one-time only, no plan toggle

  // SG bundle table: four ONE-TIME box bundles, no subscription. `strike` is
  // the compare-at total (qty × the S$115 single-box price); saving = strike
  // gap + the S$9.90 shipping every bundle ships free. variant ids are the
  // LIVE fhzisg-0b.myshopify.com "Immority MoveOn" product (9720132305139),
  // prices/compare-at match the store (115/205+230/259+345/499+690).
  var BUNDLES = [
    { t: '1 box',   boxes: 1, days: 30,  sach: 30,  price: 115, strike: 0,   pct: 0,  variant: 50274990194931, plan: 0 },
    { t: '2 boxes', boxes: 2, days: 60,  sach: 60,  price: 205, strike: 230, pct: 11, variant: 50274990227699, plan: 0 },
    { t: '3 boxes', boxes: 3, days: 90,  sach: 90,  price: 259, strike: 345, pct: 25, variant: 50274990260467, plan: 0 },
    { t: '6 boxes', boxes: 6, days: 180, sach: 180, price: 499, strike: 690, pct: 28, variant: 50274990293235, plan: 0 }
  ];

  var state = { slide: 0, gal: 0, bundle: 2, plan: DEFAULT_PLAN, bar: false, cartOpen: false, cart: null };

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function fmt(n) { return 'S$' + (Number.isInteger(n) ? String(n) : n.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function savingOf(b) { return (b.strike ? b.strike - b.price : 0) + 9.9; }
  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }

  /* ---------------------------------------------------------------- hero -- */
  var heroTrack = $('[data-hero-track]');
  var heroDots = $$('[data-hero-dot]');
  var heroCount = heroTrack ? heroTrack.children.length : 0;
  var heroTimer = null;

  function renderHero() {
    if (!heroTrack) return;
    heroTrack.style.transform = 'translateX(-' + (state.slide * 100) + '%)';
    heroDots.forEach(function (d, i) { d.classList.toggle('is-active', i === state.slide); });
  }

  function startHeroTimer() {
    if (heroTimer) clearInterval(heroTimer);
    if (!heroCount || reduceMotion) return;
    heroTimer = setInterval(function () {
      state.slide = (state.slide + 1) % heroCount;
      renderHero();
    }, AUTOPLAY_MS);
  }

  heroDots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      state.slide = i;
      renderHero();
      startHeroTimer();          // picking a dot restarts the clock, as in the comp
    });
  });

  /* ------------------------------------------------------------- gallery -- */
  var galSlides = $$('[data-gal-slide]');
  var galThumbs = $$('[data-gal-thumb]');

  function renderGallery() {
    galSlides.forEach(function (img, i) { img.classList.toggle('is-active', i === state.gal); });
    galThumbs.forEach(function (b, i) {
      b.classList.toggle('is-active', i === state.gal);
      b.setAttribute('aria-current', i === state.gal ? 'true' : 'false');
    });
  }

  galThumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { state.gal = i; renderGallery(); });
  });

  /* ------------------------------------------------- bundle / plan / cart -- */
  var offerRoot = $('[data-offer]');
  var bundleBtns = $$('[data-bundle]');
  var cart = $('[data-cart]');

  function renderPricing() {
    var B = BUNDLES[state.bundle];
    var now = B.price;

    bundleBtns.forEach(function (btn, i) {
      var b = BUNDLES[i];
      btn.classList.toggle('is-selected', i === state.bundle);
      btn.setAttribute('aria-pressed', i === state.bundle ? 'true' : 'false');
      var was = $('[data-b-was]', btn);
      var nowEl = $('[data-b-now]', btn);
      var save = $('[data-b-save]', btn);
      if (was) { was.textContent = b.strike ? fmt(b.strike) : ''; was.style.display = b.strike ? 'block' : 'none'; }
      if (nowEl) nowEl.textContent = fmt(b.price);
      if (save) { save.textContent = b.pct ? 'Save ' + b.pct + '%' : ''; save.style.display = b.pct ? '' : 'none'; }
    });

    setText('[data-cta-price]', fmt(now));
    setText('[data-bar-bundle]', B.t);

  }

  bundleBtns.forEach(function (btn, i) {
    BUNDLES[i].img = btn.getAttribute('data-bundle-img') || '';
    btn.addEventListener('click', function () { state.bundle = i; renderPricing(); });
  });

  function setCart(open) {
    state.cartOpen = open;
    if (!cart) return;
    cart.classList.toggle('is-open', open);
    cart.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var close = $('[data-cart-close]', cart);
      if (close) close.focus();
    }
  }

  /* AU cart drawer, ported from pdp-au.js: the drawer is front-end state that
     slides out the moment Add to cart is clicked. The real Shopify cart is only
     built when Checkout is pressed (and off Shopify that build fails silently
     and we navigate anyway). */
  var CHECK_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand-2)" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:none;margin-top:3px"><path d="M4 12.5l5.5 5.5L20 6.5"></path></svg>';

  function perksHtml(b) {
    var rows = [
      'Free Singapore-wide shipping <s style="color:var(--color-text-2)">S$9.90</s>',
      'Dispatched in 1 business day, tracked delivery'
    ];
    if (b.strike) rows.unshift(fmt(b.strike - b.price) + ' off versus buying single boxes');
    return rows.map(function (r) {
      return '<span style="display:flex;align-items:flex-start;gap:9px;font-family:var(--font-sans);font-size:15px;line-height:1.4;color:var(--color-text)">' + CHECK_SVG + '<span>' + r + '</span></span>';
    }).join('');
  }

  function syncCart() {
    var c = state.cart;
    if (!c) return;
    var b = BUNDLES[c.bundle];
    setText('[data-cart-bundle]', 'MoveOn™ · ' + b.t);
    setText('[data-cart-plan]', 'One-time purchase · ' + b.days + '-day supply');
    setText('[data-cart-qty]', c.qty);
    setText('[data-cart-line]', fmt(c.unit * c.qty));
    setText('[data-cart-saving]', '− ' + fmt(Math.round(savingOf(b) * c.qty * 100) / 100));
    setText('[data-cart-subtotal]', fmt(c.unit * c.qty));
    var perks = $('[data-cart-perks]');
    if (perks) perks.innerHTML = perksHtml(b);
    var cartImg = $('[data-cart-img]');
    if (cartImg) cartImg.style.backgroundImage = 'url(' + b.img + ')';
  }

  /* Repeat add of the same selection increments; a different selection replaces
     the line — the drawer renders exactly one item, like the AU PDP. */
  function addToCart() {
    var same = state.cart && state.cart.bundle === state.bundle;
    if (same) state.cart.qty += 1;
    else {
      var B = BUNDLES[state.bundle];
      state.cart = { bundle: state.bundle, plan: 'once', qty: 1, unit: B.price };
    }
    syncCart();
    setCart(true);
  }

  $$('[data-add-to-cart]').forEach(function (b) {
    b.addEventListener('click', function () { addToCart(); });
  });
  $$('[data-qty-inc]').forEach(function (b) {
    b.addEventListener('click', function () { if (state.cart) { state.cart.qty += 1; syncCart(); } });
  });
  $$('[data-qty-dec]').forEach(function (b) {
    b.addEventListener('click', function () { if (state.cart && state.cart.qty > 1) { state.cart.qty -= 1; syncCart(); } });
  });

  /* Checkout: mirror the drawer into the real Shopify cart, then hand off. */
  $$('[data-checkout]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var c = state.cart;
      if (!c) return;
      e.preventDefault();
      var B = BUNDLES[c.bundle];
      if (!B.variant) { window.location.href = a.getAttribute('href') || '#offer'; return; }
      var item = { id: B.variant, quantity: c.qty };
      var post = function (url, body) {
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body || {})
        });
      };
      post('/cart/clear.js')
        .then(function () { return post('/cart/add.js', { items: [item] }); })
        .catch(function () {})
        .then(function () { window.location.href = a.getAttribute('href') || '/checkout'; });
    });
  });
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function () { setCart(true); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { setCart(false); }); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.cartOpen) setCart(false);
  });

  /* ---------------------------------------------------------- accordions -- */
  // Single-open per group, matching the comp (faqOpen defaults to item 0,
  // the offer's ingredient accordion defaults to closed).
  $$('[data-acc]').forEach(function (group) {
    var items = $$('.mo-acc-item', group);
    items.forEach(function (item) {
      var btn = $('.mo-acc-btn', item);
      var panel = $('.mo-acc-panel', item);
      var sym = $('.mo-acc-sym', item);
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var willOpen = !panel.classList.contains('is-open');
        items.forEach(function (other) {
          var p = $('.mo-acc-panel', other);
          var b = $('.mo-acc-btn', other);
          var s = $('.mo-acc-sym', other);
          if (p) p.classList.remove('is-open');
          if (b) b.setAttribute('aria-expanded', 'false');
          if (s) s.textContent = '+';
        });
        if (willOpen) {
          panel.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (sym) sym.textContent = '−';
        }
      });
    });
  });

  /* --------------------------------------------------------- sticky bar -- */
  var stickyBar = $('[data-sticky-bar]');

  function onScroll() {
    var show = window.scrollY > 620;
    if (show === state.bar) return;
    state.bar = show;
    if (stickyBar) stickyBar.classList.toggle('is-up', show && SHOW_STICKY);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* -------------------------------------------------------------- video -- */
  // Every [data-pro] clip stays muted and looping, and can never be unmuted.
  // Only the clips actually on screen are told to play: there are 16 of them, and
  // asking a browser to run 16 concurrent streams (worse inside an embedded
  // preview iframe, e.g. the Shopify theme editor) is what makes them sit frozen
  // on the poster frame. The observer keeps 2-3 playing at a time instead.
  var vids = $$('video[data-pro]');
  var onScreen = new WeakSet();

  // Save-Data / slow connection: never pull video, the poster frames carry the section.
  var conn = navigator.connection || {};
  var lowData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');

  function tryPlay(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  // src lives in data-src, so a clip costs nothing until it is actually reached.
  // Five 480p clips is still ~11 MB, which has no business downloading during a
  // page load nobody has scrolled yet.
  function ensureSrc(v) {
    if (v.dataset.src && !v.src) {
      v.preload = 'auto';
      v.src = v.dataset.src;
    }
  }

  function forceMute() {
    vids.forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.volume = 0; v.loop = true;
      if (v.paused && onScreen.has(v) && v.src) tryPlay(v);
    });
  }

  if ('IntersectionObserver' in window && !lowData) {
    var vObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          onScreen.add(v);
          ensureSrc(v);
          v.muted = true; v.loop = true;
          tryPlay(v);
        } else {
          onScreen.delete(v);
          if (!v.paused) v.pause();
        }
      });
    }, { rootMargin: '100px 0px', threshold: 0.01 });
    // wait for load so video never competes with the content people came for
    var startObserving = function () { vids.forEach(function (v) { vObs.observe(v); }); };
    if (document.readyState === 'complete') setTimeout(startObserving, 300);
    else window.addEventListener('load', function () { setTimeout(startObserving, 300); });
  } else if (!lowData) {
    vids.forEach(function (v) { onScreen.add(v); ensureSrc(v); });
  }

  forceMute();
  document.addEventListener('volumechange', forceMute, true);
  document.addEventListener('pause', forceMute, true);
  setInterval(forceMute, 3000);
  // an embedded preview can start hidden; re-assert when it becomes visible
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) forceMute();
  });

  /* -------------------------------------------------------- review wall -- */
  function startReviewWall() {
    var cols = $$('.mo-vcol');
    if (!cols.length || reduceMotion) return;
    var wall = $('.mo-vwall');
    var paused = false;
    var holdTimer = null;

    function hold() { paused = true; if (holdTimer) clearTimeout(holdTimer); }
    function release(ms) {
      if (holdTimer) clearTimeout(holdTimer);
      holdTimer = setTimeout(function () { paused = false; }, ms);
    }

    if (wall) {
      wall.addEventListener('pointerenter', hold);
      wall.addEventListener('pointerleave', function () { release(200); });
      wall.addEventListener('touchstart', hold, { passive: true });
      wall.addEventListener('touchend', function () { release(2500); }, { passive: true });
      wall.addEventListener('wheel', function () { hold(); release(2000); }, { passive: true });
    }

    var pos = cols.map(function (c) { return c.scrollTop; });
    cols.forEach(function (c, i) {
      c.addEventListener('scroll', function () {
        // adopt the user's position when they drag a column themselves
        if (paused || Math.abs(c.scrollTop - Math.round(pos[i])) > 2) pos[i] = c.scrollTop;
      }, { passive: true });
    });

    var last = performance.now();
    (function step(now) {
      var dt = Math.min((now - last) / 1000, 0.08);
      last = now;
      if (!paused) {
        cols.forEach(function (c, i) {
          var half = c.scrollHeight / 2;   // each track holds the cards twice
          if (half < 40) return;
          var track = c.firstElementChild;
          var speed = Number(track && track.dataset.speed) || 20;
          var p = pos[i] + speed * dt;
          if (p >= half) p -= half;
          pos[i] = p;
          c.scrollTop = Math.round(p);
        });
      }
      requestAnimationFrame(step);
    })(last);
  }

  /* ------------------------------------------------------------- chart --- */
  function startChartReveal() {
    var chart = $('.mo-chart');
    if (!chart) return;
    if (!('IntersectionObserver' in window)) { chart.classList.add('is-in'); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.35 });
    obs.observe(chart);
  }

  /* --------------------------------------------------------------- init -- */
  renderHero();
  startHeroTimer();
  renderGallery();
  renderPricing();
  onScroll();
  startReviewWall();
  startChartReveal();
})();

/* Copy/save protection: no context menu or drag on media, no copy of page text. */
(function () {
  var root = document.querySelector('.mo-listicle');
  if (!root) return;
  root.addEventListener('contextmenu', function (e) {
    if (e.target.closest('img, video')) e.preventDefault();
  });
  root.addEventListener('dragstart', function (e) {
    if (e.target.closest('img, video, a')) e.preventDefault();
  });
  root.addEventListener('copy', function (e) { e.preventDefault(); });
})();
